module.exports = __webpack_public_path__ + "static/media/shaolaishan2.5921ee85.jpg";